export default "__VITE_ASSET__9688b4b4__"